/**
 * 驾驶舱管理 - 简体中文
 */
export default {
  title: '驾驶舱',
  targetManage: '目标管理',
  performanceReview: '业绩复盘',
  setTarget: '设定目标',
  // 目标管理列表
  newTarget: '新目标',
  addTarget: '添加目标',
  currentMonthTarget: '本月目标',
  targetIncome: '目标收入',
  currentIncome: '当前收入',
  actualIncome: '实际收入',
  completionRate: '完成度',
  timeProgress: '时间进度',
  daysRemaining: '剩余{n}天',
  notStarted: '未开始',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  operationReminder: '操作提醒',
  deleteTargetConfirm: '删除目标后将会导致当前已提交的业绩数据清零，同时该目标包含的销售人员任务也将清空，请确认是否继续删除？',
  // 设定目标/目标详情
  exit: '退出',
  targetDetail: '目标详情',
  targetSetting: '目标设定',
  targetPeriod: '目标周期',
  selectMonth: '选择月',
  machinePart: '学习机部分',
  estimatedRevenue: '预计收入',
  estimatedTip: '(根据官方参考零价预估)',
  model: '机型',
  targetQty: '目标台数',
  supervisorPart: '督学部分',
  optional: '选填',
  totalTargetIncome: '总目标收入',
  nextStepAssign: '下一步，分配目标',
  viewAssignTarget: '查看分配目标',
  assignTip: '已根据你的目标设定为所有下级经销商进行了智能分配，您可对【台数】和【督学收入】进行手动修改',
  addOrRemoveAgent: '添加/删除经销商',
  ratioMode: '比例模式填写',
  incomeMode: '收入模式填写',
  resetToDefault: '恢复至默认方案',
  machineIncomeRatio: '学习机收入比例',
  machineIncome: '学习机收入',
  supervisorIncomeRatio: '督学收入比例',
  supervisorIncome: '督学收入',
  totalIncomeTarget: '总收入目标',
  yuan: '元',
  // 业绩复盘
  agentId: '代理商Id',
  placeholderAgentId: '请输入代理商Id',
  campusId: '经销商Id',
  placeholderCampusId: '请输入经销商Id',
  clearFilter: '清除筛选',
  agent: '代理商',
  agentType: '代理商类型',
  targetName: '目标名称',
  campusIdCol: '经销商ID',
  totalIncomeTargetCol: '总收入目标',
  totalIncomeAchieved: '总收入达成',
  totalIncomeCompletion: '总收入完成度',
  qtyTarget: '台数目标',
  qtyAchieved: '台数达成',
  qtyCompletion: '台数完成度',
  qtyDetail: '台数明细',
  machineIncomeTarget: '学习机收入目标',
  machineIncomeAchieved: '学习机收入达成',
  machineIncomeCompletion: '学习机收入完成度',
  supervisorIncomeTarget: '督学收入目标',
  supervisorIncomeAchieved: '督学收入达成',
  supervisorIncomeCompletion: '督学收入完成度',
  machineModel: '学习机型号',
  // setTarget 设定目标
  total: '总计',
  backToTargetSetting: '返回，到目标设定',
  addRemoveAgent: '添加删除经销商',
  select: '选择',
  submitTargetConfirm: '提交目标后当前目标将下发至您指定的经销商，并将于',
  submitTargetConfirmEnd: '正式生效，请确认是否继续提交',
  submitTargetConfirmFull: '提交目标后当前目标将下发至您指定的经销商，并将于{date}正式生效，请确认是否继续提交',
  effectiveDate: '{year}年{month}月1日',
  switchModeConfirm: '确定切换填写模式？',
  switchModeTip: '所有员工收入比例将重新调整，请谨慎操作！',
  dealerId: '经销商ID',
  dealerName: '经销商姓名',
  queryFailed: '查询失败',
  selectTargetPeriod: '请选择目标周期',
  performanceReviewExport: '业绩复盘导出',
  selectTargetPeriodRequired: '请选择目标周期！',
  fillMachineQtyRequired: '请至少填写一个学习机机型的台数！',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  assignTargetToDealer: '请至少给一个经销商分配目标',
  machineIncomeRatio100: '学习机收入配比总和的为100%',
  supervisorIncomeRatio100: '督学收入配比总和的为100%',
  targetSuffix: '目标',
  machineTotalNotMatchTarget: '所有经销商学习机总收入不等于学习机目标收入，请重新调整',
  supervisorTotalNotMatchTarget: '所有经销商督学总收入不等于督学目标收入，请重新调整',
};
